import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Camera from "./components/Camera/Camera";
import ScrollToTop from "./components/ScrollToTop";
import VantaBackground from "./components/Camera/VantaBackground";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

const AppContent = () => {
  return (
    <>
      <VantaBackground /> {/* Render VantaBackground at the root level */}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Camera />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <Router>
      <div className="App no-scroll">
        <AppContent />
      </div>
    </Router>
  );
}

export default App;
